// extracted by mini-css-extract-plugin
module.exports = {"B2BNavigation":"B2BNavigation_B2BNavigation__3Lwzn","B2BNavigationItem":"B2BNavigation_B2BNavigationItem__1j3dz"};